export enum HttpContentType {
  Json = 'application/json',
  MultipartFormData = 'multipart/form-data',
  Pdf = 'application/pdf',
  html = 'text/html',
}
